export const tawktolink =
  "https://tawk.to/chat/5fbcf6e7a1d54c18d8ecd77d/1ff5pe1gm"
